module.exports = __webpack_public_path__ + "static/media/sm.f1d07953.svg";